module.exports = __webpack_public_path__ + "img/verimedia-logo.d9ea3947.png";